<cbc-container [isLoading]="false" [showContainer]="true" title="Profissões">
</cbc-container>

<div class="card mobile-responsive-table" [class.is_mobile]="isMobile">
  @if(isMobile){
  <button mat-flat-button class="btn btn-primary mb-md" (click)="addProfession()">
    Adicionar Profissão
  </button>
  }

  <table #table mat-table [dataSource]="councilProfessions" multiTemplateDataRows [class.isMobile]="isMobile">
    <ng-container matColumnDef="certifiedHubMedical">
      <th mat-header-cell *matHeaderCellDef class="col-icon"></th>
      <td mat-cell *matCellDef="let element" class="col-icon">
        <img [src]="
            element.certifiedHubMedical
              ? 'assets/icons/icon_certificado_concedido.svg'
              : 'assets/icons/icon_certificado_ausente.svg'
          " [matTooltip]="
            element.certifiedHubMedical
              ? 'Certificado Hub Medical'
              : 'Não certificado'
          " width="24px" alt="" />
      </td>
    </ng-container>

    <ng-container matColumnDef="professionName">
      <th mat-header-cell *matHeaderCellDef>Profissão</th>
      <td mat-cell *matCellDef="let element" class="col-mobile-content">
        <span class="mobile-label">Profissão: </span>
        {{ element.professionInfo?.professionName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="specialty">
      <th mat-header-cell *matHeaderCellDef>Especialidade</th>
      <td mat-cell *matCellDef="let element" class="col-mobile-content">
        <span class="mobile-label">Especialidade: </span>
        {{ element.professionInfo?.specialty }} 
        @if(element.professionInfo?.specialtyRQE){
        (RQE: {{ element.professionInfo?.specialtyRQE }})
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="activityArea">
      <th mat-header-cell *matHeaderCellDef>Áreas de Atuação</th>
      <td mat-cell *matCellDef="let element" class="col-mobile-content">
        <span class="mobile-label">Áreas de Atuação: </span>
        <ul>
          <li *ngFor="let area of element.professionInfo?.activityAreas">
            {{ area.activityArea }}
            <span *ngIf="area.activityAreaRQE">(RQE: {{ area.activityAreaRQE }})</span>
          </li>
        </ul>
      </td>
    </ng-container>

    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">
        <button mat-flat-button class="btn btn-primary" (click)="addProfession()">
          Adicionar Profissão
        </button>
      </th>
      <td mat-cell *matCellDef="let element" class="col-actions">
        @if(!element.certifiedHubMedical){
        <button mat-icon-button (click)="deleteProfession(element)" matTooltip="Excluir profissão">
          <img src="assets/icons/svg_hm_icon_perfil_conselho_excluir.svg" alt="" />
        </button>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsCouncilProfession"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumnsCouncilProfession"
      [class.expanded-row]="expandedElementCouncilProfession === element"></tr>
  </table>
</div>